import React from 'react';

export default function EmpateaWho() {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Para quem é?</h2>
        <div className="w-16 h-1 bg-gradient-to-r from-primary-500 to-secondary-500 mx-auto"></div>
      </div>

      <p className="text-lg text-gray-800 text-center max-w-3xl mx-auto leading-relaxed">
        Psicólogos, terapeutas ocupacionais, fonoaudiólogos, pedagogos, estudantes e profissionais da saúde
        e educação que buscam uma prática ética, empática e neuroafirmativa.
      </p>
    </div>
  );
}
